// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import {
    canViewMenuGroup,
    canViewMenuItem,
    resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from '@layouts/utils'
import {useSelector} from "react-redux";

const VerticalMenuNavItems = props => {
    // ** Context
    /*const ability = useContext(AbilityContext)*/

    // ** Components Object
    const Components = {
        VerticalNavMenuSectionHeader,
        VerticalNavMenuGroup,
        VerticalNavMenuLink
    }
    const auth = useSelector(state => state.auth)
    const notification = useSelector(state => state.notification)
    // ** Render Nav Menu Items
    const RenderNavItems = props.items.map((item, index) => {
        if (item.id === "requests") {
            if (notification.notify) {
                let nottt = notification.notify;
                let badge1 = parseInt(nottt["3"]);
                let badge2 = parseInt(nottt["5"]);
                let badge3 = parseInt(nottt["8"]);
                let sumBadge = badge1 + badge2 + badge3;
                if (sumBadge !== 0) {
                    item.badge = "warning";
                    item.badgeText = sumBadge;
                } else {
                    delete item.badge;
                    delete item.badgeText;
                }

                if (item.children.length > 0) {
                    item.children.map((child, child_index) => {
                        if (child.id === "adminWarrantyRequests") {
                            if (badge1 > 0) {
                                child.badge = "warning";
                                child.badgeText = badge1;
                            } else {
                                delete item.badge;
                                delete item.badgeText;
                            }
                        }
                        if (child.id === "adminUseWarrantyRequests") {
                            if (badge2 > 0) {
                                child.badge = "warning";
                                child.badgeText = badge2;
                            } else {
                                delete item.badge;
                                delete item.badgeText;
                            }
                        }
                        if (child.id === "adminPartRequests") {
                            if (badge3 > 0) {
                                child.badge = "warning";
                                child.badgeText = badge3;
                            } else {
                                delete item.badge;
                                delete item.badgeText;
                            }
                        }
                    })
                }
            }
        }

        const TagName = Components[resolveNavItemComponent(item)]
        if (item.children) {
            return canViewMenuGroup(item, auth) && <TagName item={item} index={index} key={item.id} {...props}  />
        }
        return canViewMenuItem(item, auth) && <TagName key={item.id || item.header} item={item} {...props} />
    })

    return RenderNavItems
}

export default VerticalMenuNavItems
